import UploadCSV from "./uploadCSV/UploadCSV";
import MergeBoard from "../mergeBoard/MergeBoard";

import DesktopArchiveMenu from './Archive/DesktopArchiveMenu';
import ArchiveDialog from './Archive/ArchiveDialog';
import ManageFields from './Archive/ManageFields';
import { useArchiveState } from "./Archive/hooks/useArchiveState";

function Archive({ isOwner, isAdmin, boardId }) {
  const {
    anchorEl,
    archiveDialog,
    callback,
    currentBoard,
    handleCSV,
    handleClick,
    handleClose,
    handleCloseDialog,
    handleFeedClick,
    handleManageFields,
    handleMergeBoard,
    handleWorklogsClick,
    isArchive,
    loading,
    open,
    openCSV,
    openManageFields,
    openMergeBoard,
    setArchiveDialog,
    setOpenCSV,
    setOpenManageFields,
    setOpenMergeBoard,
  } = useArchiveState(boardId);

  return (
    <>
      <DesktopArchiveMenu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClick}
        isAdmin={isAdmin}
        isOwner={isOwner}
        isArchive={isArchive}
        onArchiveClick={() => setArchiveDialog(true)}
        onFeedClick={handleFeedClick}
        onWorklogsClick={handleWorklogsClick}
        onCSVClick={handleCSV}
        onMergeBoardClick={handleMergeBoard}
        onManageFieldsClick={handleManageFields}
      />
      {archiveDialog && (
        <ArchiveDialog
          open={archiveDialog}
          onClose={handleCloseDialog}
          onSubmit={callback}
          loading={loading}
          isArchive={isArchive}
        />
      )}
      {openCSV && <UploadCSV openCSV={openCSV} closeCSV={setOpenCSV} />}
      {openMergeBoard && (
        <MergeBoard
          close={setOpenMergeBoard}
          open={openMergeBoard}
          currentBoard={currentBoard}
        />
      )}
      {openManageFields && (
        <ManageFields
          open={openManageFields}
          close={() => setOpenManageFields(false)}
          currentBoard={currentBoard}
        />
      )}
    </>
  );
}

export default Archive;
